'use client';

import { useState, useEffect, useCallback } from 'react';  // 添加 useCallback
import Image from 'next/image';

interface RatingProps {
  gameId: string;
}

export const Rating = ({ gameId }: RatingProps) => {
  const [rating, setRating] = useState(0);
  const [voteCount, setVoteCount] = useState(0);
  const [hasRated, setHasRated] = useState(false);
  const [hoverRating, setHoverRating] = useState(0);
  const [error, setError] = useState('');

  const fetchRating = useCallback(async () => {
    try {
      const response = await fetch(`/api/ratings?gameId=${gameId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch rating');
      }
      const data = await response.json();
      if (data.success) {
        setRating(parseFloat(data.average));
        setVoteCount(data.count);
      } else {
        setError(data.error || 'Failed to fetch rating');
      }
    } catch (error) {
      console.error('Error fetching rating:', error);
      setError('Failed to fetch rating');
    }
  }, [gameId]); // 添加依赖

  useEffect(() => {
    fetchRating();
  }, [fetchRating]); // 更新依赖

  const handleRating = async (score: number) => {
    if (hasRated) {
      alert('You have already rated this game');
      return;
    }

    try {
      const response = await fetch('/api/ratings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          gameId, 
          rating: score 
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit rating');
      }

      const data = await response.json();
      if (data.success) {
        setRating(parseFloat(data.newAverage));
        setVoteCount(data.newCount);
        setHasRated(true);
        setError('');
      } else {
        setError(data.error || 'Failed to submit rating');
      }
    } catch (error) {
      console.error('Error submitting rating:', error);
      setError('Failed to submit rating');
    }
  };

  return (
    <div className="rate-block flex items-center">
      {error && (
        <div className="text-red-500 text-sm mb-2">{error}</div>
      )}
      <div className="rating mr-12" style={{ width: '110px' }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <Image
            key={star}
            src={`/images/star-${star <= (hoverRating || rating) ? 'on' : 'off'}-big.png`}
            alt={star.toString()}
            width={24}
            height={24}
            className="inline-block cursor-pointer"
            onMouseEnter={() => !hasRated && setHoverRating(star)}
            onMouseLeave={() => setHoverRating(0)}
            onClick={() => handleRating(star)}
          />
        ))}
      </div>
      <span className="rate-info whitespace-nowrap">
        <span className="mr-4">{voteCount} votes</span>
        <span className="rating-num gorgeous">{rating.toFixed(1)}</span>
        <span className="rating-num gorgeous">/5</span>
      </span>
    </div>
  );
};

export default Rating;